import { type ComponentProps } from 'react';

import { TranslateHtml } from '@change-corgi/core/react/i18n';
import { Avatar } from '@change-corgi/design-system/components/media';
import { Box, Flex } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import type { HeroFeedItem as HeroFeedItemType } from 'src/app/pages/psf/promoteOrShare/pageContext';

type Props = {
	item: HeroFeedItemType;
};

export const ITEM_MIN_HEIGHT = 30;

export function HeroFeedItem({ item, ...rest }: Props & ComponentProps<typeof Flex>) {
	return (
		<Flex
			sx={{ justifyContent: 'center', alignItems: 'center', minHeight: ITEM_MIN_HEIGHT }}
			data-qa="hero-feed-item"
			data-hero-feed-item-type={item.event.__typename}
			{...rest}
		>
			<Flex mr={16}>
				<Avatar src={item.userPhoto || ''} variant="subtle" alt="" />
			</Flex>
			<Box sx={{ flex: 1 }}>
				<Text as="div" breakWord>
					{item.event.__typename === 'HeroFeedPromotionEvent' ? (
						<TranslateHtml
							value="fe.components.psf.promote_or_share.combo_feed.promote_activity_text"
							replacements={{
								promoter_name: item.userDisplayName,
								amount_formatted: item.event.amountLocalizedWithCurrency ?? '',
							}}
						/>
					) : (
						<TranslateHtml
							value="fe.components.psf.promote_or_share.combo_feed.share_activity_text"
							replacements={{
								sharer_name: item.userDisplayName,
							}}
						/>
					)}
				</Text>
			</Box>
		</Flex>
	);
}
